module.exports = __webpack_public_path__ + "img/THIRD.72071016.svg";